import gsap from 'gsap'
import Swiper, { Navigation, Pagination, Scrollbar } from 'swiper'
Swiper.use([Navigation, Pagination, Scrollbar])

export default class MobileSwiper {
  constructor(container) {
    this.DOM = { container }
    this.DOM.swiperNavigation = this.DOM.container.querySelector('.swiper-navigation')

    this.swiper = null

    // MatchMedia variable
    this.mm = gsap.matchMedia()
    // Breakpoint
    this.breakpoint = 768
    // Responsive object
    this.responsiveObj = {
      isDesktop: `(min-width: ${this.breakpoint}px)`,
      isMobile: `(max-width: ${this.breakpoint - 1}px)`
    }

    this.setMobileSwiper()
  }

  setMobileSwiper() {
    this.mm.add(this.responsiveObj, (context) => {
      const { isMobile } = context.conditions

      if (isMobile) {
        this.enableSwiper()
      } else {
        if (this.swiper) this.swiper.destroy(true, true)
      }
    })
  }

  enableSwiper() {
    const { container, swiperNavigation } = this.DOM

    this.navigation = false

    if (swiperNavigation) {
      this.navigation = {
        prevEl: container.querySelector('.prev'),
        nextEl: container.querySelector('.next')
      }
    }

    this.swiper = new Swiper(container, {
      speed: 350,
      spaceBetween: 20,
      longSwipesRatio: 0.1,
      slidesPerView: 'auto',
      navigation: this.navigation
    })
  }

  destroy() {
    if (this.swiper) this.swiper.destroy(true, true)
  }
}
